module.exports = __webpack_public_path__ + "static/media/circle-banner-secondary.f7d4c24e.svg";